import { render, staticRenderFns } from "./UserPreviewCard.vue?vue&type=template&id=9ad40ca2&scoped=true&"
import script from "./UserPreviewCard.vue?vue&type=script&lang=js&"
export * from "./UserPreviewCard.vue?vue&type=script&lang=js&"
import style0 from "./UserPreviewCard.vue?vue&type=style&index=0&id=9ad40ca2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ad40ca2",
  null
  
)

export default component.exports